document.addEventListener('DOMContentLoaded', () => {
	// updateOnChange
	const updateOnChange = document.querySelectorAll('.updateOnChange');
	const searchParams = new URLSearchParams(window.location.search);

	updateOnChange.forEach((item) => {
		item.addEventListener('change', () => {
			const params = [];

			updateOnChange.forEach((element) => {
				if (element.checked) {
					params.push(element.name);
				}

				params.push(element.value);
			});
			searchParams.set(item.name, params.toString());

			if (!params.length) {
				searchParams.delete(item.name);
			}

			window.location.search = searchParams.toString();
		});
	});

	// numbers only
	const numberInputs = document.querySelectorAll('.input-number');

	numberInputs.forEach((item) => {
		item.addEventListener('keyup', (e) => {
			item.value = item.value.replace(/\D+/g, '');
		});
	});

	// pass compare
	const form = document.getElementById('password-form');
	if (form) {
		form.addEventListener('submit', (e) => {
			const passes = form.querySelectorAll('.passCompare');

			if (passes.length < 2) return;

			if (passes[0].value != passes[1].value) {
				passes[1].setCustomValidity('Passwords is not equal!');
				passes[1].reportValidity();

				e.preventDefault();
			} else {
				passes.forEach((input) => {
					input.addEventListener('input', () => {
						input.setCustomValidity('');
					});
				});
			}
		});
	}

	// input copy
	const copyInputs = document.querySelectorAll('.input-copy');

	copyInputs.forEach((input) => {
		const button = input.querySelector('button');
		const inputText = input.querySelector('input');

		button.addEventListener('click', () => {
			inputText.select();
			document.execCommand('copy');

			input.classList.add('copied');

			setTimeout(() => {
				input.classList.remove('copied');
			}, 1000);
		});
	});

	const priceFormatter = (price) =>
		new Intl.NumberFormat(document.documentElement.lang, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(price);

	// qtt
	$(document).on('change', '.qty', function () {
		const price = parseFloat($(this).attr('data-price-for-subtotal'));
		const priceVat = parseFloat($(this).attr('data-price-for-subtotal-vat'));
		const qtt = $(this).val();

		$('.calculated-sub-total').text(priceFormatter(price * qtt));
		$('.calculated-sub-total-vat').text(priceFormatter(priceVat * qtt));
		$("[name='update_cart']").prop( 'disabled', false ).trigger('click').prop( 'disabled', true );
	});

	$(document).on('click', 'button.qttup, button.qttdown', function() {
		var qty = $(this).parents('.qtt-group').find('input.qty');
		var val = parseFloat(qty.val());
		var max = parseFloat(qty.attr('max'));
		var min = parseFloat(qty.attr('min'));
		var step = parseFloat(qty.attr('step'));
		var qtt = 0;

		if ($(this).is('.qttup')) {
			if (max && max <= val) {
				qtt = max;
			} else {
				qtt = val + step;
			}
		} else {
			if (min && min >= val) {
				qtt = min;
			} else if (val > 1) {
				qtt = val - step;
			}
		}

		qty.val(qtt).change();

		const price = parseFloat(qty.attr('data-price-for-subtotal'));
		const priceVat = parseFloat(qty.attr('data-price-for-subtotal-vat'));

		$('.calculated-sub-total').text(priceFormatter(price * qtt));
		$('.calculated-sub-total-vat').text(priceFormatter(priceVat * qtt));
		$("[name='update_cart']").prop( 'disabled', false ).trigger('click').prop( 'disabled', true );
	});
});
